import { makeAutoObservable, runInAction } from 'mobx';
import { request } from '@/common';

class Store {
  constructor() {
    makeAutoObservable(this);
  }

  /** 标签列表 */
  tabList = [];
  /** 数据列表 */
  data = [];
  /** 当前选中的tab */
  activeTab = 0;

  /** 获取列表 */
  getData() {
    request.get('/ai_agent/example/index').then((res) => {
      
      runInAction(() => {
        this.data = res.data.list;
      });
    });
  }

  /** 设置当前选中的tab */
  setActiveTab(tab) {
    this.activeTab = tab;
  }

}

const agentSquareStore = new Store();
export default agentSquareStore;